import { createContext } from "react";

export type MenuDrawerDisplayType = "sticky" | "rail" | "hidden";
//
export const MenuDrawerContext = createContext<
  | {
      displayType: MenuDrawerDisplayType;
      setDisplayType: (displayType: MenuDrawerDisplayType) => void;
      displayTypeOverride: MenuDrawerDisplayType | undefined;
      setDisplayTypeOverride: (
        displayType: MenuDrawerDisplayType | undefined,
      ) => void;
      isOnScreen: boolean;
      setIsOnScreen: (onScreen: boolean) => void;
      isMobileDisplayType: boolean;
      isMobileViewport: boolean;
      isRailDisplayType: boolean;
      isStickyDisplayType: boolean;
      subMenuIndex: number | undefined;
      setSubMenuIndex: (index: number | undefined) => void;
    }
  | undefined
>(undefined);
